<template>
  <div class="rechargerecordNew">
    <div class="section" v-if="!showInvoice && !showInvoiceView">
      <!-- 查询 -->
      <div class="search">
        <div class="datePreNext">
        <span class="date-icon"></span>
        <!-- 上一天 -->
        <span class="date-btn date-pre" @click="toPreDay"></span>
          <el-date-picker v-model="datevalue" :editable="false" popper-class="select-date"
          :picker-options="pickerrangeOptions" @change="queryData(true)" :placeholder="$t('rosRecharge.pleaseSelectDate')"
          ref="datePickerRange"></el-date-picker>
        <span class="date-btn date-next" @click="toNextDay"></span>
        </div>
        <!-- 搜索 -->
        <el-button class="button button-solid" @click.stop="showSearchBtn">
          <i class="el-icon-search"></i>
        </el-button>
        <div class="search-alert" v-show="showSearch">
          <div class="searchDiv">
            <el-input
              class="searchAll"
              ref="iptFocus"
              v-model.trim="searchDatalogger.orderno"
              @keyup.enter.native="queryData(true)"
              :placeholder="$t('rosRecharge.orderNo')"
              clearable
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <!-- 搜索 -->
            <span class="search-device" @click="queryData(true)">{{ $t('recharge.Search') }}</span>
            <!-- 取消 -->
            <span class="search-hide" @click="closeSearch">{{ $t('datalogger.cancel') }}</span>
          </div>
        </div>

        <!-- 批量操作弹条 (显隐由是否勾选决定) -->
        <div class="batch-alert" v-show="selectedDatalogger.length">
          <!-- 当前选中条数 -->
          <span
            class="batch-total"
          >{{ `${$t('alarm.curSelected')} ${selectedDatalogger.length} ${$t('alarm._Data')}` }}</span>
          <div class="batch-right">
            <!-- 操作 -->
            <span class="batch-operate">
              <!-- 充值 -->
              <span class="btn" @click="openRecharge(selectedDatalogger)">
                <span class="">{{$t('rosRecharge.batchInvoicing')}}</span>
                <i class="ico iconfont icon-invoiceList"></i>
              </span>
            </span>
            <!-- 取消 -->
            <span class="batch-hide" @click="closeBatch">{{ $t('rate.cancel') }}</span>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        height="100%"
        class="tablemain tableloding"
        border
        v-loading="elLoading"
        :data="dataloggerList"
        stripe
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        element-loading-spinner="el-icon-loading"
        @selection-change="handleSelectionChange"
        :empty-text="$t('account.nodata')"
        ref="multiplePayTable"
      >
        <el-table-column fixed type="selection" width="55px"></el-table-column>
        <el-table-column prop="gts" :show-overflow-tooltip="true" :label="this.$t('recharge.Time')"></el-table-column>
        <el-table-column prop="orderNo" :label="this.$t('recharge.Order_Number')"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column  :label="this.$t('recharge.Datalogger_PN')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
            
            <el-tooltip v-if="scope.row.pns.length>1" class="item" effect="dark" :content="scope.row.pns.join(',')" placement="top-start">
              <span >{{scope.row.pns[0]+`(${scope.row.pns.length})`}}</span>
           </el-tooltip>

            <span v-else>{{scope.row.pns[0]}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column  :label="this.$t('recharge.CCID')" :show-overflow-tooltip="true"
          min-width="80px">
            <template slot-scope="scope">
            <el-tooltip v-if="scope.row.ccIds.length>1" class="item" effect="dark" :content="scope.row.ccIds.join(',')" placement="top-start">
              <span >{{scope.row.ccIds[0]+`(${scope.row.ccIds.length})`}}</span>
           </el-tooltip>
            <span v-else>{{scope.row.ccIds[0]}}</span>
          </template>
          </el-table-column> -->
        <el-table-column prop="orderType" :label="$t('rosRecharge.rechargeType')"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.orderType === 0 ? $t('rosRecharge.trafficRecharge') : $t('rosRecharge.collectRecharge') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="months" :label="$t('rosRecharge.rechargeDuration')"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.orderType === 0||scope.row.priceType==1||scope.row.priceType==3">{{ scope.row.months }}{{ $t('rosRecharge.month') }}</span>
            <span v-else-if="scope.row.priceType==2">{{ scope.row.days }}{{ $t('rosRecharge.days') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" :label="this.$t('recharge.Recharge_money')"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>¥{{scope.row.amount}}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="105"
          :label="$t('rosRecharge.rechargeStatus')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              class="color-normal"
            >
            {{$t('rosRecharge.rechargeSuccess')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="this.$t('recharge.Operation')"
          fixed="right"
          width="100"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              class="operation"
              :title="$t('rosRecharge.invoice')"
              @click="openRecharge([scope.row])"
            >
              <i class="ico iconfont icon-invoiceList"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="tablebottom">
        <!-- 批量占位 -->
        <div style="margin-left:10px;"></div>
        <!-- jumper -->
        <el-pagination
          class="pagination"
          background
          @size-change="queryData(true)"
          @current-change="() => queryData()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total"
          popper-class="select-page"
        >
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <invoice-form
      v-else-if="showInvoice && !showInvoiceView"
      :invoiceData="currentInvoiceData"
      @back="handleInvoiceBack"
      @submit="handleInvoiceSubmit"
      @viewStatus="handleViewStatus"
    />
    <invoice-view
      v-else
      :invoiceResult="currentInvoiceResult"
      @back="handleInvoiceViewBack"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import filter from "@/assets/js/filter";
import invoiceForm from "./invoiceForm";
import invoiceView from "./invoiceView";
export default {
  components: { invoiceForm, invoiceView },
  data() {
    return {
       datevalue: "",
       pickerrangeOptions: {
           disabledDate: time => {
               return time.getTime() > Date.now() - 8.64e6
           },
       },
      searchDatalogger: {
        // status: "",
        // pn: "",
        // load: "",
        // cardType: "",
        // ccid: "",
        orderno: ""
      },
      pagination: {
        currentPage: 1,
        pagesize: 15,
        // 默认 0
        total: 100
      },
      dataloggerList: [],
      selectedDatalogger: [],
      elLoading: false,
      // 搜索弹出
      showSearch: false,
      // 开票页面
      showInvoice: false,
      currentInvoiceData: null,
      showInvoiceView: false,
      currentInvoiceResult: null,
    };
  },
  mounted() {
    this.queryData();
  },
  computed: {
    ...mapState({
      // 角色
      role: state => {
        return {
          id: state.user.role,
          name: filter.role(state.user.role).name,
          group: filter.role(state.user.role).group
        };
      }
    })
  },
  methods: {
        // 切换上一天
    toPreDay () {
      let aimTime = this.$filter.formatDate(this.$refs.datePickerRange.value, "yyyy-MM-dd");
      let preDay = this.$tool.getYestoday(aimTime);
      // this.datevalue = preDay;
      if (/^\d{4}-\d{2}-\d{2}$/.test(preDay)) {
        const [y, m, d] = preDay.split('-');
        this.datevalue = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.datevalue = preDay;
      }
    },
    // 切换下一天
    toNextDay () {
      let dayValue= new Date(this.$refs.datePickerRange.value)
      if (dayValue>Date.now()-8.64e7) return this.$message.warning(this.$t("device.noDate"));
      let aimTime = this.$filter.formatDate(this.$refs.datePickerRange.value, "yyyy-MM-dd");
      let nextDay = this.$tool.getNextday(aimTime);
      // this.datevalue = nextDay;
      if (/^\d{4}-\d{2}-\d{2}$/.test(nextDay)) {
        const [y, m, d] = nextDay.split('-');
        this.datevalue = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.datevalue = nextDay;
      }
    },
    //获取列表数据
    queryData(reset) {
      if (reset) this.pagination.currentPage = 1;
      let param = {
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize,
        // cardStatus: this.searchDatalogger.status,
        // ccid: this.searchDatalogger.ccid,
        // load: this.searchDatalogger.load,
        orderno: this.searchDatalogger.orderno,
        date: this.datevalue ? this.$filter.formatDate(this.datevalue, "yyyy-MM-dd") : ""
        // cardType: this.searchDatalogger.cardType,
        // type: 0
      };
      this.elLoading = true;
      this.$request.getDEVMicroservices("/ros/api/rechargeInvoice/listInvoicableOrders", param).then(res => {
        console.log(res,"res")
        if (res.code == 0) {
          this.dataloggerList = res.data.order;
          this.pagination.total = res.data.total;
        } else {
          this.dataloggerList = [];
          this.pagination.total = 0;
        }
        this.elLoading = false;
      });
    },
    // 切换数采器列表选中项
    handleSelectionChange(selection) {
      this.selectedDatalogger = selection;
    },
    // 打开充值弹窗
    openRecharge(dataloggers) {
      this.currentInvoiceData = dataloggers;
      this.showInvoice = true;
    },
    // 关闭搜索框
    closeSearch() {
      this.showSearch = false;
    //   this.searchDatalogger.status = "";
    //   this.searchDatalogger.pn = "";
    //   this.searchDatalogger.load = "";
    //   this.searchDatalogger.cardType = "";
    //   this.searchDatalogger.ccid = "";
      this.searchDatalogger.orderno = "";
      this.queryData(true);
    },
    showSearchBtn() {
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      });
    },
    // 关闭批量操作弹条
    closeBatch() {
      this.$refs.multiplePayTable.clearSelection();
    },
    // 返回开票页面
    handleInvoiceBack() {
      this.showInvoice = false;
      this.currentInvoiceData = null;
      this.selectedDatalogger = [];
      this.queryData(true);
    },
    // 提交开票数据
    handleInvoiceSubmit(formData) {
      console.log('提交开票数据：', formData);
      // TODO: 调用 API 提交
      this.showInvoice = false;
      this.currentInvoiceData = null;
    },
    // 查看开票状态
    handleViewStatus() {
      this.showInvoice = false;
      this.showInvoiceView = true;
      this.currentInvoiceResult = {}; // TODO: 填充实际开票结果
    },
    // 从发票查看页返回
    handleInvoiceViewBack() {
      this.showInvoiceView = false;
      this.currentInvoiceResult = null;
      this.selectedDatalogger = [];
      this.queryData(true);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.rechargerecordNew {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  overflow: auto;

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }

    /deep/.el-range__icon {
        margin-left: 25px;
    }

    /deep/.el-date-editor--daterange {
        color: #fff;
        background-color: #2b3842;
    }

    /deep/.el-range-input {
        color: #fff;
        background-color: #222d35;
        width: 160px;
    }

    /deep/.el-range-separator {
        color: #fff;
        width: 18%;
        line-height: 48px;
    }

    /deep/.el-icon-date:before {
        content: "";
        display: inline-block;
        position: absolute;
        top: 12px;
        left: 10px;
        height: 24px;
        width: 24px;
        background: url(../../../assets/img/general/Icon_Calendar.png) no-repeat;
        background-size: 100%;
        background-position: center;
    }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .searchDiv {
          position: absolute;
          top: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {
          /deep/.el-input__inner {
            width: 220px;
            // padding-left: 10px;
            padding: 0 20px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #33FFB6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #7b8395;
          border-left: 1px solid #7b8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        // /deep/.el-input .el-input__clear {
        //   width: 48px;
        //   color: #7b8395;
        // }

        // /deep/.el-input .el-input__clear:hover {
        //   background: @primaryColorTransparency30;
        //   color: rgb(255, 255, 255, 1);
        // }

        // /deep/.el-input .el-input__inner,
        // /deep/.el-input .el-input__inner:hover {
        //   height: 48px;
        //   border-radius: 0px;
        //   border: none;
        //   background: #202d35;
        //   color: #ffffff;
        //   padding-left: 40px;
        // }

        // /deep/.el-input__prefix {
        //   left: 0px;
        // }

        // /deep/.el-input__icon {
        //   width: 40px;
        // }

        // /deep/.el-input__suffix {
        //   right: 0px;
        // }

        // /deep/.el-input__suffix:hover {
        //   background: @primaryColorTransparency30;
        //   color: rgb(255, 255, 255, 1);
        // }

        // /deep/.el-icon-circle-close:before {
        //   content: "X";
        // }

        // /deep/.el-input:not(:last-child) {
        //   margin-right: 0px;
        // }
      }
          // 日期盒子
    .datePreNext {
      padding: 0px 16px;
      // border-left: 1px solid #7B8395;
      border-right: 1px solid #7B8395;

      /deep/.datepicker {
        margin: 0px;
        // margin-right: 16px;
      }

      /deep/.el-date-editor {
        margin-right: 16px;
      }

      /deep/.el-date-editor.el-input {
        width: 150px;
      }

      /deep/.el-date-editor.el-input .el-input__inner {
        padding: 0px;
        text-align: center;
      }

      //.el-input__prefix,
      //.el-input__suffix
      /deep/.el-input__prefix {
        display: none;
      }

      /deep/.el-input__suffix {
        top: 2px;
        right: 0px;
      }

      .date-icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url(../../../assets/img/general/Icon_Calendar.png);
        background-size: 100%;
        background-position: center;
        background-repeat: no-repeat;
        vertical-align: middle;
        margin-right: 16px;
      }

      .date-pre {
        background: url(../../../assets/img/general/Chart_Date_Pre.png);
      }

      .date-next {
        background: url(../../../assets/img/general/Chart_Date_Next.png);
      }

      .date-btn {
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        height: 16px;
        width: 16px;
        background-size: 100%;
        background-position: center;
        background-repeat: no-repeat;
        vertical-align: middle;
      }
    }
    }

    .link-detail {
      color: @primaryTextColor;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    .tableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox
        .el-checkbox__input.is-indeterminate
        .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          background-color: #2b3842;
          color: #15c491;
        }

        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }

  // 批量操作弹条
  .batch-alert {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    z-index: 1;
    background: rgba(255, 231, 107, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .batch-total {
      padding-left: 16px;
      font-size: 14px;
    }

    .batch-right {
      display: flex;
      justify-content: flex-end;
    }

    .batch-hide {
      height: 48px;
      line-height: 48px;
      padding: 0px 16px;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        background: rgba(255, 255, 255, 1);
      }
    }

    .batch-operate {
      display: flex;
      justify-content: flex-end;

      .btn {
        color: rgba(34, 45, 53, 1);
        font-size: 14px;
        cursor: pointer;
        // height: 48px;
        // line-height: 48px;
        padding: 0px 16px;
        border-radius: 0px;
        display: flex;
        align-items: center;

        &:hover {
          background: rgba(255, 255, 255, 1);
        }
      }

      .ico-pay {
        background: url(../../../assets/img/general/Icon_Batch_Pay.png);
      }

      .ico {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 8px;
      }
    }
  }
}
</style>
<style lang="less">
// #分页下拉框#
.select-page {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 12px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
    background-color: rgb(34, 45, 53);
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    min-width: 110px;
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }
}

.rechargerecordNew {
  .el-table--border::after,
  .el-table--group::after {
    display: none;
  }
}
</style>
